export default "__VITE_ASSET__$ABIcUmE__"